import { StoreDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { Button, message, notification } from 'antd';
import { FC, useCallback, useState } from 'react';

import { errorObjectToString } from 'src/utils/common';
import { callMaintainStore } from 'src/utils/firebase/firebase-callable';

const AgCellSyncStoreMenuByNaverPlace: FC<ICellRendererParams<StoreDoc>> = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storeMenu = data?.storeMenu;

  const handleSyncStoreMenu = useCallback(async () => {
    setIsLoading(true);
    try {
      const storeId = data?._id;
      if (!storeId) {
        throw new Error('storeId is required');
      }
      if (data?.lat === undefined || data?.lng === undefined) {
        throw new Error('lat or lng is required');
      }
      await callMaintainStore({ storeId, operations: ['updateStoreMenu'] });
      message.success('메뉴 동기화 요청 완료');
    } catch (error) {
      const description = errorObjectToString(error);
      notification.error({
        message: '메뉴 동기화 요청 실패',
        description,
      });
    }
    setIsLoading(false);
  }, [data]);

  return (
    <span>
      {storeMenu && <>메뉴 {storeMenu.length}개 </>}
      <Button size='small' loading={isLoading} onClick={handleSyncStoreMenu}>
        동기화
      </Button>
    </span>
  );
};

export default AgCellSyncStoreMenuByNaverPlace;
